import Vue from 'vue'
import { Picker, Field, Popup, Toast } from 'vant';
import 'vant/lib/index.css';
import App from './App.vue'
import router from './router'

import api from '@/public/request'

// 跳转微信OAuth2 获取code
let userAgentL = navigator.userAgent.toLowerCase()
if (userAgentL.indexOf('micromessenger') !== -1 || userAgentL.indexOf('wechat') !== -1) {
  console.log('在微信中打开', localStorage.getItem("WEIXIN_OAUTH2_IS"));
  // 判断是否已经获取过用户信息
  if (localStorage.getItem("WEIXIN_OAUTH2_IS") == null) {
    // 解析get请求
    let get_params = [];
    if (window.location.search) {
      let get_param_source = window.location.search.substring(1).split("&");
      for (let _item of get_param_source) {
        let _pair = _item.split('=');
        get_params[_pair[0]] = _pair[1];
      }
    }
    console.log('GET参数', get_params);
    if (get_params['code'] && get_params['state']) {
      // 保存code
      console.log('已经获得微信授权',get_params);
      localStorage.setItem("WEIXIN_OAUTH2_CODE", get_params['code']);
      localStorage.setItem("WEIXIN_OAUTH2_STATE", get_params['state']);
    } else {
      // 跳转OAuth2
      let url = window.location.href;
      let jump_url = 'https://wxproxy.iukun.com/oauth2/authorize?scope=snsapi_userinfo&token=64381e3156a84b269f30df0953eb0f44&redirect_url=' + encodeURIComponent(url);
      console.log('跳转url',jump_url);
      window.location.href = jump_url;
    }
  }
}


Vue.use(Picker);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Toast);

console.log('process.env.NODE_ENV',process.env.NODE_ENV)
console.log('process.env.VUE_APP_TITLE',process.env.VUE_APP_TITLE)

const windowHeight = window.innerHeight
Vue.directive('fixedInput', function (el) {
  el.addEventListener('blur', function () {
    let windowFocusHeight = window.innerHeight
    if (windowHeight == windowFocusHeight) {
      return
    }
    let currentPosition;
    let speed = 1; //页面滚动距离
    currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
    currentPosition -= speed;
    window.scrollTo(0, currentPosition); //页面向上滚动
    currentPosition += speed; //speed变量
    window.scrollTo(0, currentPosition); //页面向下滚动
  })
})

Vue.prototype.$api = api
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
